const getters = {
  id: state => state.user.id,
  sidebar: state => state.app.sidebar,
  camp_id: state => state.camp_agricole.camp_id,
  camp_label: state => state.camp_agricole.camp_label,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  userId: state => state.user.id,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  email: state => state.user.email,
  user: state => state.user.user,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  controleur: state => state.user.controleur,
  isSuperviseurGrade: state => {
    const grade = state.user.controleur && state.user.controleur.grade;
    return !!(grade && grade.nom === 'Superviseur');
  },
  userRoleLabel: state => {
    const grade = state.user.controleur && state.user.controleur.grade;
    if (grade && grade.nom) {
      return grade.nom;
    }
    return state.user.roles && state.user.roles.length ? state.user.roles.join(' | ') : '';
  },
  permissionRoutes: state => state.permission.routes,
  addRoutes: state => state.permission.addRoutes,
};
export default getters;
